import { z } from "zod/v4";

export const StripeApiCouponDurationList = [
  "forever",
  "once",
  "repeating",
] as const;
export type StripeApiCouponDuration =
  (typeof StripeApiCouponDurationList)[number];

export const StripeApiCouponDtoSchema = z.object({
  id: z.string(),
  amountOff: z.number().nullable(),
  duration: z.enum(StripeApiCouponDurationList),
  durationInMonths: z.number().nullable(),
  name: z.string(),
  percentOff: z.number().nullable(),
  maxRedemptions: z.number().nullable(),
  baseAmount: z.number().nullish(),
});

export type StripeApiCouponDto = z.infer<typeof StripeApiCouponDtoSchema>;

export const StripeApiCreateCouponDtoSchema = StripeApiCouponDtoSchema.omit({
  id: true,
});
export type StripeApiCreateCouponDto = z.infer<
  typeof StripeApiCreateCouponDtoSchema
>;
